import React from "react";
import { Input } from "antd";
import AnswerResult from "../../../partials/answerResult";

const { TextArea } = Input;

interface Props {
    content: any;
    userAnswer: string;
    setUserAnswer: (val: string) => void;
    isSubmitting: boolean;
    handleSubmitAnswer: () => void;
    answerResults: any[];
    answerResult: any | null;
    setAnswerResult: (res: any) => void;
}

const TextContent: React.FC<Props> = ({
                                          content,
                                          userAnswer,
                                          setUserAnswer,
                                          isSubmitting,
                                          handleSubmitAnswer,
                                          answerResults,
                                          answerResult,
                                          setAnswerResult
                                      }) => {
    return (
        <div className="p-4">
            <div
                dangerouslySetInnerHTML={{
                    __html: content.detail,
                }}
                style={{ marginBottom: "15px" }}
            />
            <TextArea
                rows={8}
                placeholder="Type your answer here..."
                value={userAnswer}
                onChange={(e) => setUserAnswer(e.target.value)}
                disabled={isSubmitting}
                onCopy={(e) => {e.preventDefault()}}
                onPaste={(e) => {e.preventDefault()}}
                onCut={(e) => {e.preventDefault()}}
            />
            <div className="d-flex justify-content-between align-items-center mt-2">
                <div className="text-muted small">
                    Words:{" "}
                    {userAnswer.trim()
                        ? userAnswer.trim().split(/\s+/).length
                        : 0}
                    , Characters: {userAnswer.length}
                </div>
            </div>
            <div className="d-flex justify-content-end">
                <button
                    className="mt-3 btn btn-success d-flex align-items-center"
                    onClick={handleSubmitAnswer}
                    disabled={!userAnswer.trim() || isSubmitting}
                >
                    {isSubmitting && (
                        <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                        />
                    )}
                    {isSubmitting
                        ? "Agent is evaluating..."
                        : "Submit Answer"}
                </button>
            </div>
            {answerResults.length > 0 && (
                <div className="mt-4">
                    <div className="card border-0 shadow-sm">
                        <div className="card-body">
                            <h5 className="mb-3">
                                <i className="isax isax-document-text me-2" />
                                My Writing Tasks (
                                {answerResults.length})
                            </h5>
                            <div className="list-group">
                                {answerResults.map((result, index) => (
                                    <button
                                        key={result.id}
                                        type="button"
                                        className={`list-group-item list-group-item-action d-flex justify-content-between align-items-center ${
                                            answerResult?.id === result.id
                                                ? "active"
                                                : ""
                                        }`}
                                        onClick={() => setAnswerResult(result)}
                                    >
                                        <div className="d-flex align-items-center flex-grow-1">
                                            <div className="text-start">
                                                <div className="fw-medium">
                                                    {new Date(
                                                        result.created_at
                                                    ).toLocaleDateString("en-US", {
                                                        month: "short",
                                                        day: "numeric",
                                                        year: "numeric",
                                                        hour: "2-digit",
                                                        minute: "2-digit",
                                                    })}
                                                </div>
                                                <div
                                                    className="small text-muted text-truncate"
                                                    style={{ maxWidth: "300px" }}
                                                >
                                                    {result.answer.substring(0, 60)}
                                                    {result.answer.length > 60
                                                        ? "..."
                                                        : ""}
                                                </div>
                                            </div>
                                        </div>
                                        <span
                                            className={`badge ${
                                                parseInt(result.score) >= 70
                                                    ? "bg-success"
                                                    : parseInt(result.score) >= 50
                                                        ? "bg-warning"
                                                        : "bg-danger"
                                            }`}
                                        >
                                          {result.score}
                                        </span>
                                    </button>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            )}
            {answerResult && answerResult !== null && (
                <AnswerResult answerResult={answerResult} />
            )}
        </div>
    );
};

export default TextContent;